import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { GoChevronRight } from 'react-icons/go';

function ExploreOurBlog() {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };

  const imageStyle = {
    objectFit: 'cover',
    width: 'auto',
    maxWidth: '100%',
    height: 'auto',
    // filter: 'opacity(3) brightness(2)',
  };

  const containerStyle = {
    marginBottom: '10px',
    marginTop: '10px',
    position: 'relative',
    maxWidth: '100%',
    overflow: 'hidden', // Added to hide overflowing content
  };

  const contentContainerStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    textAlign: 'center',
  };

  const buttonStyle = {
    fontSize: '11px',
    fontWeight: 600,
    border: 'none',
    width: '100%', // Make the button take up full width on small screens
    backgroundColor: isHovered ? '#F7F9FF' : '#FFE114',
    color: isHovered ? 'black' : 'black',
    transition: 'background-color 0.5s ease-in-out, color 0.5s ease-in-out, transform 0.3s',
    transform: isHovered ? 'translateX(10px)' : 'translateX(0)',
  };

  return (
    <div style={{ margin: "-8px 0 0 0", padding: 0, position: "relative" }}>
      <div style={containerStyle}>
        <img
          src={process.env.PUBLIC_URL + "/assets/images/HomeBlog.png"}
          className="d-block w-100"
          alt=""
          style={{ ...imageStyle, width: "100%" }}
        />
        <div style={contentContainerStyle}>
          <Button
          // className='animated-imaget'
            variant="warning"
            size="lg"
            active
            style={buttonStyle}
            href="/Blogs"
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
          >
            &nbsp;&nbsp; Explore Our Blogs &nbsp;&nbsp;
            <span style={{ fontSize: "11px" }}>
              <GoChevronRight />
            </span>
            &nbsp;&nbsp;
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ExploreOurBlog;
